import { render, staticRenderFns } from "./MapGroup.vue?vue&type=template&id=2cb784da&"
import script from "./MapGroup.vue?vue&type=script&lang=ts&"
export * from "./MapGroup.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports